import { lazyLoadMedia } from './utils/lazyload';
import { initSwiper } from './library/swiper';
import { initFancybox } from './library/fancybox';
import { initNotyf } from './library/notification';
import { initializeTabs } from './library/tabs';
import { initTooltip } from './library/typpy';
import { initMarquee } from './library/marquee';
import { modal } from './library/modal';
import { initAccordion } from './library/accordion';
import {initPhone} from "./main/initPhone";
import {initUp} from "./main/initUp";
import {initHeader} from "./main/initHeader";
import {initMaterial} from "./main/initMaterial";
/*import 'dragscroll';*/
document.addEventListener('DOMContentLoaded', () => {
    lazyLoadMedia();
    initPhone();
    //initAccordion();
    initSwiper();
    initUp();
    initHeader();
    initMaterial();
    // initFancybox();
    // initNotyf();
    // initializeTabs();
    // initTooltip();
    // initMarquee();
    modal;
});

